import type { DateCellData } from './types';

const options: Intl.DateTimeFormatOptions = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
};

export const DEFAULT_LANG: DateCellData['lang'] = 'en-GB';
export const DateEnUS = new Intl.DateTimeFormat('en-US', options);
export const DateEnGB = new Intl.DateTimeFormat('en-GB', options);
export const DateEnCA = new Intl.DateTimeFormat('en-CA', options);
